import { exec } from '../common/exec';
import { getLang } from '../common/utils';
export * from './type';
export * from './number';
/**
 * 通过语种获取当前数字系统小数点
 * @param lang 语种
 * @returns
 */
export function getDecimalSeparator(lang) {
    lang = getLang(lang);
    return exec('getDecimalSeparator', {}, [lang]);
}
/**
 * 通过语种获取当前数字系统格式化配置
 * @param lang 语种
 * @returns
 */
export function getNumSysFormatConf(lang) {
    lang = getLang(lang);
    return exec('getNumSysFormatConf', {}, [lang]);
}
/**
 *通过语种获取当前数字系统格式化字符串
 * @param num
 * @param lang
 * @returns
 */
export function numberFormat(num, lang, options) {
    if (isNaN(num) || (!num && num !== 0)) {
        return NaN;
    }
    lang = getLang(lang);
    return exec('numberFormat', {}, [num, lang, options]);
}
/**
 *基于 Intl 自动推测数字简写
 * @param num
 * @param lang
 * @param options
 * @returns
 */
export function numberCompact(num, lang, options) {
    if (isNaN(num) || (!num && num !== 0)) {
        return NaN;
    }
    lang = getLang(lang);
    return exec('numberCompact', {}, [num, lang, options]);
}
/**
 *固定量级数字简写
 * @param num
 * @param lang
 * @param options
 * @returns
 */
export function numberCompactByCon(num, conversion, lang) {
    if (isNaN(num) || (!num && num !== 0)) {
        return NaN;
    }
    conversion = conversion || 1000;
    lang = getLang(lang);
    return exec('numberCompactByCon', {}, [num, conversion, lang]);
}
/**
 *通过语种格式化货币金额
 * @param amount
 * @param currency
 * @param lang
 * @returns
 */
export function currencyFormat(amount, currency, lang, options) {
    if (isNaN(amount) || (!amount && amount !== 0)) {
        return NaN;
    }
    lang = getLang(lang);
    return exec('currencyFormat', {}, [amount, currency, lang, options]);
}
